import React, { useContext } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { UiButton } from "./form/UiButton";
import { Context } from "../../../_context/Store";
import { contextApiActions } from "../../../_redux/_constants";

export default function UiConfirmationDialog(props) {
     const { onClose, title, open, children } = props;

     const [state, dispatch] = useContext(Context);

     const handleCancel = () => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: { show: false },
          });
     };

     const handleOk = () => {
          state.uiConfirmationDetails.okFunction();
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: { show: false },
          });
     };

     return (
          <>
               <Dialog
                    sx={{
                         "& .MuiDialog-paper": { width: "80%", maxHeight: 435 },
                    }}
                    maxWidth="xs"
                    open={state.uiConfirmationDetails.show}
               >
                    <DialogTitle>
                         {state.uiConfirmationDetails.title}
                    </DialogTitle>
                    <DialogContent>
                         <h5>{state.uiConfirmationDetails.contentDetails}</h5>
                    </DialogContent>
                    <DialogActions>
                         <Button autoFocus onClick={handleCancel}>
                              Cancel
                         </Button>
                         <Button onClick={handleOk}>Ok</Button>
                    </DialogActions>
               </Dialog>
          </>
     );
}
